/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ProductField } from './productField';
import { ProductProductCategory } from './productProductCategory';
import { ProductSKU } from './productSKU';


export interface Product { 
    archived?: boolean;
    createdAt?: string;
    description?: string;
    featured?: boolean;
    fields?: ProductField;
    handlingPrice?: number;
    id?: string;
    imageFive?: string;
    imageFour?: string;
    imageOne?: string;
    imageThree?: string;
    imageTwo?: string;
    importObjectKey?: string;
    importSessionKey?: string;
    isRefundable?: boolean;
    locked?: boolean;
    name?: string;
    path?: string;
    price?: number;
    productCategory?: ProductProductCategory;
    published?: boolean;
    quantity?: number;
    readOnly?: boolean;
    salePrice?: number;
    shippable?: boolean;
    shippingFree?: boolean;
    skus?: ProductSKU;
    sortOrder?: number;
    taxable?: boolean;
    updatedAt?: string;
    version?: number;
    weight?: number;
}
